import { useCallback, useState } from "react";
import { useAuthUserQuery, useUpdateRecommendArticleMutation } from "@/hooks";

/**
 * useViewingArticle.
 * 会員登録完了後の挙動を設定する
 */
export function useViewingArticle() {
  const [sending, setSending] = useState(false);
  const { data } = useAuthUserQuery({ fetchPolicy: "cache-only" });
  const user = data?.user;

  const [
    updateRecommendArticle,
    { loading },
  ] = useUpdateRecommendArticleMutation();

  const setViewingArticle = useCallback(
    async ({ type, id }, force = false, redirectUrl = "") => {
      if (user) return false;
      if (!sending || force) {
        setSending(true);
        updateRecommendArticle({
          variables: {
            type,
            id,
          },
          onCompleted: () => {
            if (redirectUrl != "") {
              window.location.href = redirectUrl;
            }
          },
        });
      }
    },
    [user, sending]
  );

  return { setViewingArticle, loading };
}
